import React, { Component } from "react";
import Header from "./Header";
class Archives extends Component {
  render() {
    return (
      <div className="Archives">
      <Header></Header>
        <h2>Archives of ancient UKVAC meets from the dawn of retro gaming</h2>
  
  <table border="0" cellpadding="2" cellspacing="2" width="100%">
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/ukm1-0.htm">U.K.VAC Meeting 1.0</a></td>
      <td width="70%">Milton Keynes, February 7th, 1997</td>
    </tr>
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/ukm1-5.htm">U.K.VAC Meeting 1.5</a></td>
      <td width="70%">Milton Keynes, October 2nd, 1999</td>
    </tr>
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/ukm1-51.htm">U.K.VAC Meeting 1.5.1</a></td>
      <td width="70%">Bedford, October 2nd, 1999</td>
    </tr>
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/ukm1-6.htm">U.K.VAC Meeting 1.6 (Ravmeet)</a></td>
      <td width="70%">&quot;Rav's Muzzy Mall&quot;, February 26th, 2000</td>
    </tr>
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/ukm1-7.htm">U.K.VAC Meeting 1.7</a></td>
      <td width="70%">Swanmeet</td>
    </tr>
    <tr>
      <td width="30%"><a> U.K.VAC Meeting 1.8 (Bazmeet)</a></td>
      <td width="70%">Honiton, November xxth, 2000</td>
    </tr>
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/ukm1-85.htm">U.K.VAC Meeting 1.85 (Kipmeet)</a></td>
      <td width="70%">Chelmsford, February 3rd, 2001</td>
    </tr>
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/ukm1-95.htm">U.K.VAC Meeting 1.95</a>&nbsp;</td>
      <td width="70%">Bedford, June 3rd,2001</td>
    </tr>
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/ukm1-96.htm">U.K.VAC Meeting 1.95 (SP3)&nbsp;</a></td>
      <td width="70%">&quot;Rav's Muzzy Mall,&quot; Portsmouth, 13th June, 2001</td>
    </tr>
    <tr>
      <td width="30%"></td>
      <td width="70%"></td>
    </tr>
    <tr>
      <td width="30%"><a href="http://www.ukvac.com/UKVAC_Meets/tm1-0.htm">Tech-Meet 1.0</a></td>
      <td width="70%">&quot;Rav's Muzzy Mall&quot;, January 21st-23rd, 2000</td>
    </tr>
  </table>

      </div>
    );
  }
}
 
export default Archives;



// WEBPACK FOOTER //
// ./src/Archives.js